// Reach Us / Contact Page (Web Only)
// Displays supermedic.health/contact in an iframe with the auth navbar

import React from 'react';
import { View, StyleSheet, Platform } from 'react-native';
import { useSelector } from 'react-redux';
import { useNavigation } from '@react-navigation/native';
import WebNavbar from '../../components/web/WebNavbar';
import { webColors, webSpacing } from '../../constants/webStyles';

const ReachUsScreen = () => {
  const navigation = useNavigation();
  const { loggedIn } = useSelector((state) => state.user);

  // Redirect logged-in users to their dashboard
  React.useEffect(() => {
    if (loggedIn) {
      navigation.replace('HomeScreen');
    }
  }, [loggedIn, navigation]);

  if (Platform.OS !== 'web') {
    return null;
  }

  return (
    <View style={styles.container}>
      <View style={styles.navbarContainer}>
        <WebNavbar variant="auth" />
      </View>
      <View style={styles.iframeContainer}>
        <iframe
          src="https://www.supermedic.health/contact"
          style={styles.iframe}
          title="Contact Supermedic"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: webColors.background,
    minHeight: '100vh',
  },
  navbarContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 1000,
    paddingTop: 4,
    backgroundColor: 'white',
  },
  iframeContainer: {
    flex: 1,
    width: '100%',
    height: `calc(100vh - ${webSpacing.navbarHeight}px)`,
  },
  iframe: {
    width: '100%',
    height: '100%',
    border: 'none',
  },
});

export default ReachUsScreen;
